import TailwindConfig from '../../../../tailwind.config.js'

export const ScreenBreakpoints = {
  breakpointSm: parseInt(TailwindConfig.theme.screens.sm.replace('px', '')),
  breakpointMd: parseInt(TailwindConfig.theme.screens.md.replace('px', '')),
  breakpointMl: parseInt(TailwindConfig.theme.screens.ml.replace('px', '')),
  breakpointLg: parseInt(TailwindConfig.theme.screens.lg.replace('px', '')),
}
